export const IMPACT_STORAGE_KEY = 'ImpactPopUPDisable';

export const IMPACT_MODAL_TYPE = 'modalPopupDefault';
export const IMPACT_MODAL_TITLE_NAME = 'You are being redirected to';
export const IMPACT_MODAL_TITLE = 'IMPACT';
export const IMPACT_MODAL_COLOR = 'black';
export const IMPACT_MODAL_CANCEL_TEXT = 'No Thanks, Stay Here.';
export const IMPACT_MODAL_CONFIRM_TEXT = 'Continue';

export const IMPACT_MSG_SUCCESS = 'A new browser window will open in the IMPACT application';
export const IMPACT_MSG_PROVIDER_NOT_FOUND = 'This Genesis ID is not available in IMPACT. To continue, you will be redirected to your most recently used Genesis ID/Tax ID.';
export const IMPACT_MSG_TIN_NOT_FOUND = 'This Tax ID is not available in IMPACT. To continue, you will be redirected to your most recently used Genesis ID/Tax ID.';
export const IMPACT_TOOLTIP_TEXT_LINE1 = 'User will be redirected to';
export const IMPACT_TOOLTIP_TEXT_LINE2 = 'the IMPACT application';
